/*import config from '@/utils/config'*/
import {
  login,
  getWxUserInfo,
  setStorage,
  getStorage,
  removeStorage
} from "@/utils/wxuser";
import api from "@/utils/api";
import {
  urlEncode,
  getUrlParams,
  createUrl
} from "@/utils/index";
import {
  jAlert3,
  closeAlert
} from "@/base/jAlert/jAlert";
import { miniProgram } from "@/utils/miniProgram";
import {
  Promise
} from "es6-promise";
import {
  performance, isWeChat, isReservationMan
} from "@/utils/utils";
import { baseUrl } from "@/utils/baseUrl";
import { remove } from "store";
let isMounted = false;
var config = {};
const globalMethods = {
  data() {
    return {
      isWechatProfitSharing: '',
      priceOrCredit: '',
      hideHotelInfo: '',
      isCloseCart: ''
    };
  },
  mounted() {

    if (this.$el == document.getElementById("app") && !isMounted) {
      isMounted = true;
      performance();
    }


    // if(isReservationMan()&&getStorage('isOpenTravelAgencyMode')=='T'){
    //   this.isCloseCart = 'T'
    // }
    if (getStorage('isOpenProfitSharingShopCart')) {
      this.isOpenProfitSharingShopCart = getStorage('isOpenProfitSharingShopCart')

    }
    if (getStorage('priceOrCredit')) {
      this.priceOrCredit = getStorage('priceOrCredit')
    }
    if (getStorage('hideHotelInfo')) {
      this.hideHotelInfo = getStorage('hideHotelInfo')

    }
    this.config = getStorage("config");
    config = getStorage("config");
    var user = getStorage("user");
    if (!this.$parent) {
      let token = getStorage("token");
      let tfToken = getStorage("tfToken");
      let thirdPartyChannel = getStorage("thirdPartyChannel");
      if (token) {
        if (!(user && user.memberId)) {
          this.getMemberInfoByToken()
        }
      }
      if (tfToken && thirdPartyChannel == "tfbank") {
        this.tfGetMemberInfo();
      }
      if (user && user.memberId && user.mobile) {
        this.getToken(user);
      }


    }
  },
  created() {
    this.config = getStorage("config");
  },
  methods: {
    listShopPlantingNotesAuthor(init,cb) {
      if(getStorage("author")&&getStorage("author").id){
        return;
      }
      if(init){
        return;
      }
      var opt = {
        hotelGroupCode: config.hotelGroupCode,
        memberId: this.user.memberId,
      }
      api.listShopPlantingNotesAuthor(opt).then(res => {
        if (res.result == 1) {
          if (res.retVal.length <= 0) {
            this.saveShopPlantingAuthor(init)
          }else{
            setStorage("author", res.retVal[0]);
            cb&&cb();
          }
          
        } else {
          jAlert3(res.msg);
        }
      })
    },
    saveShopPlantingAuthor(init) {
      let wxuser = getStorage("wxuser");
      var user = getStorage("user");
      if(!user||!user.memberId){
        return;
      }
      var opt = {
        hotelGroupCode: config.hotelGroupCode,
        memberId: user.memberId,
        name: wxuser.nickname,
        avatar: wxuser.headimgurl,
        hotelCode: 0
      }
      api.saveShopPlantingAuthor(opt).then(res => {
        if (res.result == 1) {
          
          this.listShopPlantingNotesAuthor(true)
        } else {
          jAlert3(res.msg);
        }
      })
    },
    tfGetMemberInfo() {
      var config = getStorage("config");
      api.tfGetMemberInfo({
        token: getStorage("tfToken"),
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode,
      }).then(res => {
        if (res.result == 1) {
          setStorage("user", res.retVal);
          if (res.retVal && res.retVal.refreshToken) {
            setStorage("tfRefreshToken", res.retVal.refreshToken);
          }
          if (res.retVal && res.retVal.token) {
            setStorage("tfToken", res.retVal.token);
          }
          this.user = res.retVal;
        }
      })
    },
    goUrl(link) {
      if (!link) {
        return;
      } else {
        window.location.href = link
      }
    },
    queryHotelStoredName(storedNameDtos = [], cb) {
      var config = getStorage("config");
      api.queryHotelStoredName({
        hotelGroupCode: config.hotelGroupCode,
        appid: config.appid,
        storedNameDtos: storedNameDtos
      }).then(res => {
        if (res.result == 1 && res.retVal && res.retVal.storedNameDtos && res.retVal.storedNameDtos.length > 0) {
          res.retVal.storedNameDtos.forEach((n) => {
            if (!n.chuzhiAmountReplace) {
              n.chuzhiAmountReplace = "金额";
            }
            if (!n.chuzhiBalanceReplace) {
              n.chuzhiBalanceReplace = "余额";
            }
            if (!n.chuzhiCardReplace) {
              n.chuzhiCardReplace = "储值卡";
            }
            if (!n.chuzhiName) {
              n.chuzhiName = "储值";
            }
            if (!n.chuzhiReplaceCharge) {
              n.chuzhiReplaceCharge = "充值";
            }
            if (!n.chuzhiUnit) {
              n.chuzhiUnit = "元";
            }
          })
          cb && cb(res.retVal.storedNameDtos);
        }
      })
    },
    lockBody() {
      const { body } = document
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      body.style.position = 'fixed'
      body.style.width = '100%'
      body.style.top = `-${scrollTop}px`
    },
    resetBody() {
      const { body } = document
      const { top } = body.style
      body.style.position = ''
      body.style.width = ''
      body.style.top = ''
      document.body.scrollTop = -parseInt(top, 10)
      document.documentElement.scrollTop = -parseInt(top, 10)
    },
    getQueryVariable(url, variable) {
      url = url.split('?')[2]
      if (url) {
        var vars = url.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
      } else {
        return (false);
      }

    },
    getQueryVariableCommon(url, variable) {
      var query = url.split('?')
      if (query.length > 0) {
        url = query[query.length - 1]
      }

      if (url) {
        var vars = url.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
      } else {
        return (false);
      }

    },
    getMainOpenid(cb) {
      var gcPayTransMode4Shop = getStorage('gcPayTransMode4Shop')
      if (gcPayTransMode4Shop == "07") {
        var href = window.location.href
        var url = `https://wx19aca61bc2c91639.wx.gcihotel.net/wechat/?/#/thirdUrlAuth?1=1&authMember=F&scope=snsapi_base&needLogin=F&thirdUrl=${encodeURIComponent(href)}`

        window.location.href = url;
      } else {
        localStorage.removeItem('mainOpenid')
      }


    },
    async goLink(url) {
      if (!url) {
        return false;
      }
      var isMiniProgram = await miniProgram.isMiniProgram();
      if (url.indexOf("/pages") == 0 && isMiniProgram) {
        miniProgram.navigateTo({
          url: url
        });
        return false;
      }else if(url.indexOf("http") == -1&&url.indexOf("/") == -1){
        jAlert3(url)
        return false;
      }
      let newUrl = this.wrapperUrl(url);
      window.location.href = newUrl;
    },
    getToken(user) {
      var config = getStorage("config");
      api.getToken({
        appid: config.appid,
        memberId: user.memberId
      }).then(res => {
        if (res.result == 1) {
          setStorage("token", res.retVal.token);
        }
      })
    },
    async goCustomHome() {
      if (getStorage('appointPageUrl')) {
        var url = getStorage('appointPageUrl')
        var isMiniProgram = await miniProgram.isMiniProgram();
        if (url.indexOf("/pages") == 0 && isMiniProgram) {
          miniProgram.navigateTo({
            url: url
          });
          return false;
        }
        window.location.href = url;
      } else {
        if (this.$route.query.toIndex) {
          this.$router.push({
            path: "/polymerization",
            query: {
              id: this.$route.query.toIndex
            }

          });
        } else {
          var isMiniProgram = await miniProgram.isMiniProgram();
          if (isMiniProgram) {
            miniProgram.navigateTo({
              url: '/pages/mall/index'
            });
          } else {
            this.$router.push({
              path: "/index",
            });
          }

        }

      }
    },
    async isLogin() {
      var user = getStorage("user");
      if (!user || !user.memberId) {

        var url = encodeURIComponent(window.location.href);
        var isMiniProgram = await miniProgram.isMiniProgram();
        if (isMiniProgram) {
          var path = `/pages/member/memberLogin?redirect_url=${url}&clientSource=webview`;
          miniProgram.navigateTo({
            url: path
          });
          return false;
        } else {
          let distributorId = this.$route.query.distributorId || "";
          let distributorOpenid = this.$route.query.distributorOpenid || "";
          if (distributorId) {
            setStorage("distributorId", distributorId);
          }
          if (distributorOpenid) {
            setStorage("distributorOpenid", distributorOpenid);
          }
          window.location.href = '/wechat/?/#/memberLogin?redirect_url=' + url;
          return false;
        }
      } else {
        return true;
      }
    },
    formatImg(item) {
      if (item) {
        if (item != '') {
          if (item.indexOf('img') != -1) {
            return item.replace(/<img/g, '<img style="max-width:100%;height:auto;"')
          } else {
            return item
          }

        } else {
          return item
        }
      } else {
        return item
      }
    },
    wrapperUrl(url) {
      let params = getUrlParams(url);
      let paramsList = Object.keys(params);
      let token = getStorage("token") || "";
      let wrapperedUrl = "";
      var user = getStorage("user");
      if (!(user && user.memberId)) {
        wrapperedUrl = url;
        return wrapperedUrl;
      }
      try {
        const goUrl = new URL(url);
        const domain = goUrl.hostname;

        if (domain != location.hostname) {
          if (paramsList.length > 0) {
            wrapperedUrl = `${url}&token=${token}`;
          } else {
            wrapperedUrl = `${url}?token=${token}`;
          }
        } else {
          wrapperedUrl = url;
        }
      } catch (error) {
        wrapperedUrl = url;
      }
      return wrapperedUrl;
    },
    getMemberInfoByToken() {
      var config = getStorage("config");
      api.getMemberInfoByToken({
        appid: config.appid,
        token: this.$route.query.token
      }).then(res => {
        if (res.result == 1) {
          this.memberLoginByMobileAndOpenId(res.retVal.userinfo)
        } else {
          setStorage("token", "");
        }
      })
    },
    memberLoginByMobileAndOpenId(info) {
      let wxuser = getStorage("wxuser");
      let cardSrc = getStorage("cardSrc");
      let obj = {
        hotelGroupCode: config.hotelGroupCode,
        openid: wxuser.openid,
        openIdType: "WEIXIN",
        hotelCode: config.hotelCode ? config.hotelCode : 0,
        hotelGroupId: config.hotelGroupId,
        mobile: info.mobileEnc || "",
        nickName: info.name || "",
        appid: config.appid,
        sex: info.sex || "",
        idNo: info.idNo || "",
        cardSrc: cardSrc || ""
      }
      api.memberLoginByMobileAndOpenId(obj).then(res => {
        setStorage("token", "");
        if (res.result == 1) {
          setStorage("cardSrc", "");
          setStorage("user", res.retVal);
          this.user = res.retVal;
        } else {
          //失败的情况不登录 token也自动失效
        }
      })
    },

    async wechatShare(opt) {
      wx.showOptionMenu();
      if (opt.code == 'polymerization') {
        wx.ready(async function () {
          var isMiniProgram = await miniProgram.isMiniProgram();
          if (isMiniProgram) {
            miniProgram.postMessage({
              type: "share",
              title: opt.title || "精品好货", // 分享标题
              desc: opt.desc || "优惠不等人",// 分享描述
              link: opt.link, // 分享链接
              imgUrl: opt.imgUrl, // 分享图标
            })
          }
          wx.onMenuShareTimeline({
            title: opt.title || "精品好货", // 分享标题
            link: opt.link, // 分享链接
            desc: opt.desc || "优惠不等人", // 
            imgUrl: opt.imgUrl, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              if (opt.sucess) {
                opt.sucess();
              }
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              if (opt.cancel) {
                opt.cancel();
              }
            }
          });
          wx.onMenuShareAppMessage({
            title: opt.title || "精品好货", // 分享标题
            desc: opt.desc || "优惠不等人", // 分享描述
            link: opt.link, // 分享链接
            imgUrl: opt.imgUrl, // 分享图标
            type: "link", // 分享类型,music、video或link，不填默认为link
            //dataUrl: '<%=localUrl+wsc.getDataUrl()%>', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              if (opt.sucess) {
                opt.sucess();
              }
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              if (opt.cancel) {
                opt.cancel();
              }
            }
          });

          wx.error(function (res) { });
        });
      } else {
        api.wechatShareConfig({
          appid: config.appid,
          code: opt.code || "public",
          componentAppid: config.componentAppid
        })
          .then(data => {
            wx.ready(async function () {
              var isMiniProgram = await miniProgram.isMiniProgram();
              if (isMiniProgram) {
                miniProgram.postMessage({
                  type: "share",
                  title: opt.title || data.retVal.title || "精品好货", // 分享标题
                  link: opt.shareUrl || data.retVal.link, // 分享链接
                  desc: opt.desc || data.retVal.description || "优惠不等人", // 
                  imgUrl: opt.imgUrl || data.retVal.imgUrl, // 分享图标
                })
              }
              wx.onMenuShareTimeline({
                title: opt.title || data.retVal.title || "精品好货", // 分享标题
                link: opt.shareUrl || data.retVal.link, // 分享链接
                desc: opt.desc || data.retVal.description || "优惠不等人", // 
                imgUrl: opt.imgUrl || data.retVal.imgUrl, // 分享图标
                success: function () {
                  // 用户确认分享后执行的回调函数
                  if (opt.sucess) {
                    opt.sucess();
                  }
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  if (opt.cancel) {
                    opt.cancel();
                  }
                }
              });
              wx.onMenuShareAppMessage({
                title: opt.title || data.retVal.title || "精品好货", // 分享标题
                desc: opt.desc || data.retVal.description || "优惠不等人", // 分享描述
                link: opt.shareUrl || data.retVal.link, // 分享链接
                imgUrl: opt.imgUrl || data.retVal.imgUrl, // 分享图标
                type: "link", // 分享类型,music、video或link，不填默认为link
                //dataUrl: '<%=localUrl+wsc.getDataUrl()%>', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                  // 用户确认分享后执行的回调函数
                  if (opt.sucess) {
                    opt.sucess();
                  }
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  if (opt.cancel) {
                    opt.cancel();
                  }
                }
              });

              wx.error(function (res) { });
            });
          });
      }

    },
    getUserInfo() {
      let wxuser = getStorage("wxuser");
      let user = getStorage("user");
      this.$set(this, "wxuser", wxuser);
    },
    getCurrentCard() {
      let cardIndex = getStorage("cardIndex");
      let wxuser = getStorage("wxuser");
      let user = getStorage("user");
      if (this.user && this.user.memberId) {
        if (this.user.cardListDto[cardIndex]) {
          this.currentCard = this.user.cardListDto[cardIndex];
          this.currentCardIndex = cardIndex;
        } else {
          this.currentCard = this.user.cardListDto[0];
          this.currentCardIndex = 0;
          setStorage("cardIndex", 0);
        }
      } else {
        this.currentCard = {
          cardType: "",
          cardLevel: ""
        };
        this.currentCardIndex = 0;
        setStorage("cardIndex", 0);
      }
      return [this.currentCard, this.currentCardIndex];
    },

    async refreshMemberInfo(cb) {
      var isMiniProgram = await miniProgram.isMiniProgram();
      if (!isWeChat() || isMiniProgram) {
        this.refreshMember(cb);
        return false;
      }
      var self = this;
      try {
        var user = getStorage("user");
        var wxuser = getStorage("wxuser");
        if (user && user.memberId) {
          config = getStorage("config");
          api
            .memberLoginOpen({
              /*cardId: user.cardId,
              cardNo: user.cardNo,*/
              appid: config.appid,
              componentAppid: config.componentAppid,
              hotelCode: config.hotelCode,
              hotelGroupCode: config.hotelGroupCode,
              hotelGroupId: config.hotelGroupId,
              memberId: user.memberId,
              openid: wxuser.openid
            })
            .then(function (data) {
              if (data.result == 500) {
                self.$router.push({
                  path: "/netError",
                  name: "netError",
                });
                return false;
              }

              if (data.result == 1) {
                setStorage("user", data.retVal);
                self.user = getStorage("user");
                [
                  self.currentCard,
                  self.currentCardIndex
                ] = self.getCurrentCard();
                self.queryCompanyInfo()
                cb && cb();
              } else {
                var user = {};
                setStorage("user", user);
                self.user = getStorage("user");
                [
                  self.currentCard,
                  self.currentCardIndex
                ] = self.getCurrentCard();
              }
            })
            .catch(function (error) {
              jAlert3(error);
            });
        }
      } catch (e) { }
    },
    async refreshMember(cb) {
      var self = this;
      var user = getStorage("user");
      var config = getStorage("config");
      var isMiniProgram = await miniProgram.isMiniProgram();
      if (user && user.memberId) {
        let obj = {
          /* cardId: user.cardId,
          cardNo: user.cardNo, */
          memberId: user.memberId,
          hotelCode: config.hotelCode,
          hotelGroupCode: config.hotelGroupCode,
          hotelGroupId: config.hotelGroupId,
          appid: config.appid,
          componentAppid: config.componentAppid,
        }
        if (isMiniProgram) {
          obj.appid = getStorage("appid");
        }
        api.refreshMemberInfo(obj).then(function (data) {
          if (data.result == 1) {
            setStorage("user", data.retVal);
            self.user = getStorage("user");
            [
              self.currentCard,
              self.currentCardIndex
            ] = self.getCurrentCard();
            self.queryCompanyInfo()
            cb && cb();
          } else {
            var user = {};
            setStorage("user", user);
            self.user = getStorage("user");
            [
              self.currentCard,
              self.currentCardIndex
            ] = self.getCurrentCard();
          }
        })
      }
    },
    isMember() {
      if (!(this.user && this.user.memberId)) {
        jAlert3("请先登录");
        return false;
      } else {
        return true;
      }
    },
    queryCompanyInfo() {
      let user = getStorage('user')
      if (user && user.memberRoleLDtoList && user.memberRoleLDtoList.length > 0) {
        var obj = {
          appid: config.appid,
          componentAppid: config.componentAppid,
          companyCode: user.memberRoleLDtoList[0].companyCode,
          hotelGroupCode: config.hotelGroupCode,
        };
        api.queryCompanyInfo(createUrl(obj)).then((res) => {
          if (res.result == 1) {
            if (res.retVal && res.retVal.companyCode) {
              setStorage('levelCode', res.retVal.levelCode)
            } else {
              removeStorage('levelCode')
            }
          }
        });
      } else {
        removeStorage('levelCode')
      }
    },
    toLogin() {
      window.location.href = "/wechat/?/#/memberLogin?redirect_url=" + encodeURIComponent(window.location.href)

    },
    isIphoneX() {
      var self = this;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isIOS) {
        if (screen.height == 896 && screen.width == 414) {
          self.isIpx = true;
        } else if (screen.height == 812 && screen.width == 375) {
          self.isIpx = true;
        } else {
          self.isIpx = false;
        }
      }
    },
    back() {
      history.back();
    }
  },
  beforeDestroy() {
    closeAlert()
  }
};

export {
  globalMethods
};



// WEBPACK FOOTER //
// ./src/mixin/mixin.js